export async function InterconsultaCreate( 
    interResp,
    metaFecha,
    interAsu,
    interDest,
    interDestAllow,
    interObs,
    //interFile,
    tratamientoId,
    pacienteId ) {
    const formData = {
        title: `us-${pacienteId}-tr-${tratamientoId}-interconsulta-${metaFecha}`,
        slug: `us-${pacienteId}-tr-${tratamientoId}-interconsulta-${metaFecha}`,
        status: "publish",
        tratamiento: tratamientoId,
        paciente: pacienteId,
        meta: {
            interResp: interResp,
            metaFecha: metaFecha,
            interAsu: interAsu,
            interDest: interDest,
            interDestAllow: interDestAllow,
            interObs: interObs
            //interFile: interFile
        }
        
    };

	const authToken = sessionStorage.getItem( 'token' );

        try {
            const response = await fetch('https://app.tavad.com/hce/wp-json/wp/v2/interconsulta', {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }

}